// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"src-components-PriceCheck-NavigationTabs-NavigationTabs__tabItem--1ExZ0","tabSection":"src-components-PriceCheck-NavigationTabs-NavigationTabs__tabSection--1SLjr"};